// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {groupByUniqueKey} from '@benchling/js-utils';
import Backbone from 'backbone';
import React from 'react';
import _ from 'underscore';

import AnnotationsTableTabState from 'analyses/AnnotationsTableTabState';
import * as analytics from 'analytics/Analytics';
import {
  Annotation as BioJSAnnotation,
  AnnotationAttributes as BioJSAnnotationAttributes,
} from 'biojs/Annotation';
import {Sequence} from 'components/Sequence';
import FileStates, {SequenceFileState} from 'FileStates';
import {getAnnotationData} from 'molbio/annotations/AnnotationUtil';
import Annotation from 'molbio/annotations/backbone/Annotation';
import Annotations from 'molbio/annotations/backbone/Annotations';
import ExpandedAnnotationTab from 'molbio/annotations/ExpandedAnnotationTab';
import Search from 'molbio/biological-search/SearchDNAData';
// @ts-expect-error
import CRISPRAnalysisActions from 'molbio/crispr/CRISPRAnalysisActions';
import CRISPRAnalysisStore from 'molbio/crispr/CRISPRAnalysisStore';
import CRISPRAnalysisTabState from 'molbio/crispr/CRISPRAnalysisTabState';
import CRISPRDefaults from 'molbio/crispr/CRISPRDefaults';
import * as CRISPRUtil from 'molbio/crispr/CRISPRUtil';
import {createFromAnnotation} from 'molbio/feature-libraries/featureLibraryUtil';
import SaveAnnotationsAsFeaturesModal from 'molbio/feature-libraries/SaveAnnotationsAsFeaturesModal';
import {Selection} from 'molbio/maps/selectables/Selection';
import notifications from 'notifications';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import runModal from 'ui-library/runModal';
import {readableTime} from 'util/DateUtil';

const {isLeftPam} = CRISPRUtil;

async function saveAnnotationsAsFeatures(annotations: Array<Annotation>, sequence: Sequence): Promise<void> {
  const featureLibraryId = await runModal(SaveAnnotationsAsFeaturesModal, {
    annotationCount: annotations.length,
  });
  if (featureLibraryId != null) {
    // This is kind of silly - we should just do this in bulk since they are all being saved to the same library.
    const featureSavePromises = annotations.map((annotation) =>
      Promise.resolve(
        createFromAnnotation(annotation, sequence, featureLibraryId).fail((res) => {
          const friendlyMessage = notifications.getFriendlyError(res);
          notifications.error(
            <>
              Error adding <strong>{annotation.name()}</strong> to library: {friendlyMessage}
            </>
          );
        })
      )
    );
    const featureSaveResults = await Promise.allSettled(featureSavePromises);
    const successCount = featureSaveResults.filter((result) => result.status === 'fulfilled').length;
    if (successCount > 0) {
      const message =
        successCount === 1
          ? '1 feature successfully created.'
          : `${successCount} features successfully created.`;
      notifications.success(message);
    }
  }
}

function runCrisprOnAnnotations(
  annotations: Array<BioJSAnnotation>,
  analysisCid: string,
  handleStoreChangeListener: () => void,
  sequence: Sequence
): void {
  CRISPRAnalysisStore.addChangeListener(handleStoreChangeListener);
  const analysis = CRISPRDefaults.getDefaults();
  const search = new Search();
  search.addSequences([sequence]);
  search.set({sequence});
  const findGuidesParams = {analysis, search, sequence};
  const regions = annotations.map((annotation) => ({
    start: annotation.start(),
    end: annotation.end(),
  }));
  CRISPRAnalysisActions.createWithRegions(
    analysisCid,
    {
      ...analysis,
      sequence: sequence.id,
      name: `Untitled ${readableTime(new Date())}`,
      isLeftPam: isLeftPam(analysis.pam),
    },
    findGuidesParams,
    regions
  );
}

function openCrisprTab(analysisId: string, fileStates: FileStates, sequenceId: string): void {
  // CRISPR tab opens the analysis, so the store emits a change. However, since it can't emit a change
  // while already emitting a change, we defer adding the CRISPR tab.
  _.defer(() => {
    const sequenceFile = fileStates.get(sequenceId) as SequenceFileState;
    const existingTab = sequenceFile.findTab<CRISPRAnalysisTabState>(
      CRISPRAnalysisTabState,
      (tab) => tab.analysisId() === analysisId
    );
    if (existingTab != null) {
      existingTab.set({active: true});
    } else {
      const sequence = sequenceFile.model();
      sequenceFile.buffers().addTab(new CRISPRAnalysisTabState({analysisId, sequence}));
    }
  });
}

function deleteAnnotations(
  annotations: Annotations,
  toRemove: Array<BioJSAnnotation>,
  sequence: Sequence
): void {
  annotations._annotations
    .bulkDelete(toRemove, {fileUpdate: true})
    .fail(notifications.notifyError)
    .done(({message, deleted}) => {
      analytics.track('annotation', 'deleted_annotations', {
        source: 'annotations-table',
        sequence_api_id: sequence.id,
        annotation_count: deleted,
      });
      sequence.updateVersions();
      notifications.success(message);
    });
}

export class AnnotationsTableTabView extends Backbone.View<AnnotationsTableTabState> {
  sequence!: Sequence;
  annotations!: Annotations;
  sorted!: Array<Annotation>;
  selection!: Selection;
  handleStoreChangeListener!: null | (() => void);

  static initClass(): void {
    this.prototype.className = 'buffer-tab';
  }

  initialize(): void {
    this.sequence = this.model.get('sequence');
    this.annotations = this.sequence.annotations();
    this.selection = this.sequence.get('selection');
    this.handleStoreChangeListener = null;

    this.listenTo(this.annotations, 'add remove change reset', () => {
      this.render();
    });
    this.listenTo(this.annotations._annotations, 'add remove change reset', () => {
      this.render();
    });
    this.listenTo(this.sequence, 'change:writable change:permissions change:currentVersion', () => {
      this.render();
    });
    this.listenTo(this.sequence.get('_sequence'), 'change:startIndex change:locked', () => {
      this.render();
    });
  }

  handleRunCrispr(annotations: Array<BioJSAnnotation>): void {
    if (this.handleStoreChangeListener != null) {
      notifications.error('CRISPR is already running.');
      return;
    }
    const analysisCid = _.uniqueId('crispr-analysis-');
    this.handleStoreChangeListener = () => {
      // When this is first called, analysisCid may not be populated in the cidIdMap. If not, we expect this
      // to be called again in the next tick, when the store updates with the analysisCid from the newly
      // created analysis.
      // eslint-disable-next-line benchlint/no-in-operator
      if (analysisCid in CRISPRAnalysisStore.cidIdMap) {
        this.handleCrisprAnalysisStoreChange(analysisCid, FileStates.get());
      }
    };
    runCrisprOnAnnotations(annotations, analysisCid, this.handleStoreChangeListener, this.sequence);
    this.render();
  }

  handleCrisprAnalysisStoreChange(analysisCid: string, fileStates: FileStates): void {
    const {cidIdMap} = CRISPRAnalysisStore.getState();
    const analysisId = cidIdMap != null ? cidIdMap[analysisCid] : undefined;
    if (analysisId == null) {
      return;
    }
    CRISPRAnalysisStore.removeChangeListener(this.handleStoreChangeListener!);
    this.handleStoreChangeListener = null;
    openCrisprTab(analysisId, fileStates, this.sequence.id);
    this.render();
  }

  bulkEditAnnotations(
    annotations: Array<Annotation>,
    updatedProperties: Partial<BioJSAnnotationAttributes>
  ): void {
    for (const annotation of annotations) {
      const bioJSAnnotation = annotation.get('_annotation');
      const errorMessage = bioJSAnnotation.validate(
        {...bioJSAnnotation.toJSON(), ...updatedProperties},
        {sequence: this.sequence}
      );
      if (errorMessage) {
        notifications.error(errorMessage);
        return;
      }
    }

    const updates = annotations.map((a) => ({id: a.id, ...updatedProperties}));
    this.annotations._annotations
      .bulkUpdate(updates, {fileUpdate: true})
      .fail((res) => {
        notifications.notifyError(res);
      })
      .done(({updated, message}) => {
        analytics.track('annotation', 'updated_annotations', {
          source: 'annotations-table',
          sequence_api_id: this.sequence.id,
          annotation_count: updated.length,
        });
        this.sequence.updateVersions();
        notifications.success(message);
      });
  }

  update(): void {}

  remove(): this {
    super.remove();
    return this;
  }

  render(): this {
    const annotationsByCid = groupByUniqueKey(this.annotations.models, (model) => model.cid);
    renderToDOM(
      <ExpandedAnnotationTab
        annotations={this.annotations.map((annotation) => getAnnotationData(annotation, this.sequence))}
        allowFeatureEdits={this.sequence.allowFeatureEdits()}
        saveAnnotationsAsFeatures={(cids) => {
          saveAnnotationsAsFeatures(
            cids.map((cid) => annotationsByCid[cid]),
            this.sequence
          );
        }}
        runCrispr={
          this.sequence.supportsCRISPR()
            ? (cids) => {
                this.handleRunCrispr(cids.map((cid) => annotationsByCid[cid].get('_annotation')));
              }
            : null
        }
        deleteAnnotations={(cids) => {
          deleteAnnotations(
            this.annotations,
            cids.map((cid) => annotationsByCid[cid].get('_annotation')),
            this.sequence
          );
        }}
        bulkEditAnnotations={(cids, updatedProperties) => {
          this.bulkEditAnnotations(
            cids.map((cid) => annotationsByCid[cid]),
            updatedProperties
          );
        }}
        crisprInProgress={this.handleStoreChangeListener != null}
        isSingleStranded={this.sequence.isSingleStranded()}
        onToggleVisibility={(cids, visible) => {
          analytics.track('annotation', 'toggled_visibility', {
            source: 'annotations-table',
            sequence_id: this.sequence.id,
            annotation_count: cids.length,
            visible,
          });
          this.sequence.annotations().batchModify(() => {
            for (const cid of cids) {
              annotationsByCid[cid].set({visible});
            }
          });
        }}
      />,
      this.el
    );
    return this;
  }
}

AnnotationsTableTabView.initClass();
